<div class="header-container">
  <div class="titre-modale">
    <div class="left-side-container">
      <div>
        @if (procedureTitre) {
          <span>
        @if ( modeEdition && modeEdition.value) {
          <span>Modélisation</span>
        } @else {
          <span>Visualisation</span>
        }
            du logigramme de la procédure : <b>{{ procedureTitre }}</b></span>
        }
      </div>
      @if ( modeEdition && modeEdition.value) {
        <div>
          <button  mat-icon-button [matMenuTriggerFor]="menu" aria-label="Raccourcis clavier" title="Voir quelques raccourcis utiles au clavier">
            <mat-icon>information</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="custom-mat-menu">
            <mat-list role="list">
              <mat-list-item role="listitem">
                <div class="raccourci-container">
                  <b>Copier un/des élément(s) :</b>
                  <img ngSrc="assets/icons/control_icon.png" height="35" width="50" alt="ctrl icon">
                  + C
                </div>
              </mat-list-item>
              <mat-list-item role="listitem">
                <div class="raccourci-container">
                  <b>Coller un/des élément(s) :</b>
                  <img ngSrc="assets/icons/control_icon.png" height="35" width="50" alt="ctrl icon">
                  + V
                </div>
              </mat-list-item>
              <mat-list-item role="listitem">
                <div class="raccourci-container">
                  <b>Couper un/des élément(s) :</b>
                  <img ngSrc="assets/icons/control_icon.png" height="35" width="50" alt="ctrl icon">
                  + X
                </div>
              </mat-list-item>
              <mat-list-item role="listitem">
                <div class="raccourci-container">
                  <b>Tout sélectionner :</b>
                  <img ngSrc="assets/icons/control_icon.png" height="35" width="50" alt="ctrl icon">
                  + A
                </div>
              </mat-list-item>
              <mat-divider></mat-divider>
              <mat-list-item role="listitem">
                <div class="raccourci-container">
                  <b>Annuler une modification :</b>
                  <img ngSrc="assets/icons/control_icon.png" height="35" width="50" alt="ctrl icon">
                  + Z
                </div>
              </mat-list-item>
              <mat-list-item role="listitem">
                <div class="raccourci-container">
                  <b>Rétablir une modification :</b>
                  <img ngSrc="assets/icons/control_icon.png" height="35" width="50" alt="ctrl icon">
                  + Y
                </div>
              </mat-list-item>
              <mat-divider>
              </mat-divider>
              <mat-list-item role="listitem">
                <div class="raccourci-container">
                  <b>Sélection multiple :</b>
                  <img ngSrc="assets/icons/shift_icon.png" height="35" width="50" alt="ctrl icon">
                  + Séléction à la souris
                </div>
              </mat-list-item>

              <mat-list-item role="listitem">
                <div class="raccourci-container">
                  <b>Éditeur de texte riche :</b>
                  Double clique sur l'élément
                </div>
              </mat-list-item>
            </mat-list>
          </mat-menu>
        </div>
      }
    </div>
  </div>
  <div class="buttons">
    <div class="change-mode">
      <mat-slide-toggle [formControl]="modeEdition"> Mode modélisation</mat-slide-toggle>
    </div>
    <button mat-flat-button mat-dialog-close title="Fermer la modale" class="close-modale-button"  (click)="sendLogigramme()">
      <div class="wrapper">
        <mat-icon >close</mat-icon>
      </div>
    </button>
  </div>
</div>


<div style="height: 100%">
  @if (modeEdition && modeEdition.value) {
    <app-jointjs-plus [logigramme]="logigramme" [readOnly]="false" (graphChanged)="onGraphChanged($event)"></app-jointjs-plus>
  } @else {
    <app-jointjs-plus [logigramme]="logigramme" [readOnly]="true" (closeDialogEvent)="closeDialog($event)"></app-jointjs-plus>
  }
</div>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close (click)="sendLogigramme()" title="Fermer la modale">Quitter</button>
  @if (modeEdition && modeEdition.value) {
    <button mat-flat-button cdkFocusInitial title="Enregistrer le logigramme" class="save-button">
      <div class="wrapper">
        @if (isLogigrammeBeingSaved()) {
          <mat-spinner class="spinner" diameter="22"></mat-spinner>
        } @else {
          <mat-icon >save</mat-icon>
        }
        Enregistrer
      </div>
    </button>
  }
</mat-dialog-actions>

